import api from './axiosInstance';

export const getNotificationsPaged = {
  getPaged: async ({ page = 1, pageSize = 20, onlyUnread = false } = {}) => {
    try {
      const response = await api.get('/notifications', {
        params: {
          page,
          pageSize,
          onlyUnread,
        },
      });
      return response.data;
    } catch (error) {
      error.customMessage = 'No se pudieron cargar las notificaciones.';
      throw error;
    }
  },
};

export const putNotificationMarkAsRead = {
  putMarkAsRead: async (notificationId) => {
    try {
      await api.put('/notifications/mark-as-read', {
        notificationId,
      });
    } catch (error) {
      error.customMessage = 'No se pudo marcar la notificación como leída.';
      throw error;
    }
  },
};

export const putNotificationDelete = {
  putDelete: async (notificationId) => {
    try {
      await api.put('/notifications/delete', {
        notificationId,
      });
    } catch (error) {
      error.customMessage = 'No se pudo eliminar la notificación.';
      throw error;
    }
  },
};
